import { Trans } from 'react-i18next';
import { useQueryHelper } from '@anytag/shared-hooks';
import { BaseModal, BaseModalProps } from '@anytag/shared-atoms';
import { namedOperations, MarketplaceInfluencer, useUnblockInfluencerMarketplaceMutation } from '@anytag/graphql';
import { useMarketplaceDetailsContext } from '../../../marketplace-details-context';

export interface ConfirmMarkInfluencersAsAvailableModalProps extends BaseModalProps {
  resetSelectedInfluencerIds?: () => void;
  selectedInfluencerIds: Array<MarketplaceInfluencer['id']>;
}

export const ConfirmMarkInfluencersAsAvailableModal = ({
  footer,
  onClose,
  selectedInfluencerIds,
  resetSelectedInfluencerIds,
  ...restProps
}: ConfirmMarkInfluencersAsAvailableModalProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { marketplaceId } = useMarketplaceDetailsContext();
  const { callUnblockInfluencerMarketplace, loading } = useUnblockInfluencerMarketplaceMutation({
    refetchQueries: [namedOperations.Query.InfluencerWhitelist, namedOperations.Query.AllInfluencersForMarketplaceV2]
  });

  const handleMarkAsAvailable = async () => {
    try {
      await callUnblockInfluencerMarketplace({
        variables: { input: { campaignId: marketplaceId, influencerIds: selectedInfluencerIds } }
      });
      resetSelectedInfluencerIds?.();
    } catch (error) {
      enqueueSnackbar(t('failedUpdateWhitelist', { name: 'Update Whitelist Failed' }), { variant: 'error' });
    } finally {
      onClose?.();
    }
  };

  return (
    <BaseModal
      onClose={onClose}
      title={t('Modal.Mark as Available')}
      description={<Trans i18nKey="Modal.MarkAsAvailableDescription" components={{ br: <br /> }} />}
      footer={{
        ...footer,
        cancelButton: { onClick: onClose, ...footer?.cancelButton },
        submitButton: {
          loading,
          onClick: handleMarkAsAvailable,
          title: t('Button.Mark as Available'),
          ...footer?.submitButton
        }
      }}
      {...restProps}
    />
  );
};
